import { apiClient, buildQuery } from '~/api/client'
import type { AdminAssessment, AdminAssessmentDetail } from '~/api/types'

// 인증평가 읽기 API. 인증평가 "데이터" 탭에서 평가 목록·상세를 소비한다.

export interface ListAssessmentsParams {
    status?: string
    q?: string
    limit?: number
    offset?: number
}

/** GET /admin/api/services/certification/assessments — 평가 목록(상태 필터·페이지네이션). */
export function listAssessments(params: ListAssessmentsParams = {}) {
    const query = buildQuery({
        status: params.status,
        q: params.q,
        limit: params.limit,
        offset: params.offset,
    })
    return apiClient.get<AdminAssessment[]>(
        `/services/certification/assessments${query}`
    )
}

/** GET /admin/api/services/certification/assessments/{id} — 평가 상세. */
export function getAssessment(id: string) {
    return apiClient.get<AdminAssessmentDetail>(
        `/services/certification/assessments/${id}`
    )
}

/** POST .../assessments/{id}/report/regenerate — 리포트 재생성(admin). LLM 호출이라 10~20초 소요. */
export function regenerateReport(id: string) {
    return apiClient.post<AdminAssessmentDetail>(
        `/services/certification/assessments/${id}/report/regenerate`
    )
}

/** POST .../assessments/{id}/rescore — 재채점(superadmin). 점수 재계산이라 수십 초 가능. */
export function rescoreAssessment(id: string) {
    return apiClient.post<AdminAssessmentDetail>(
        `/services/certification/assessments/${id}/rescore`
    )
}

/** DELETE .../assessments/{id} — 평가 영구 삭제(superadmin). */
export function deleteAssessment(id: string) {
    return apiClient.delete<void>(`/services/certification/assessments/${id}`)
}
